import DumpYardCreate from "../components/views/dumpYard/dumpYardCreate.vue";
import DumpYard from "../components/views/dumpYard/dumpYard.vue";

const routes = [
  {
    path: "dumpYard",
    component: DumpYard,
    name: "dumpYard",
    meta: {
      description: "List of Dump Yards",
      title: "Dump Yard",
      requiresAuth: true,
    },
  },
  {
    path: "dumpYard/dumpYardCreate/:_id",
    component: DumpYardCreate,
    name: "dumpYardCreate",
    meta: {
      // description: 'Add a new Dump Yard',
      title: "Add / Update Dump Yard",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/dumpyard.route.js